import { Link, useLocation } from 'react-router-dom';
import { BidMasterLogo } from './BidMasterLogo';

const navLink = 'text-sm font-bold text-gray-500 hover:text-blue-600 transition-colors';

function ShareNavButton() {
  const location = useLocation();

  const share = async () => {
    const url = `${window.location.origin}${location.pathname}${location.search}`;
    const payload = { title: 'BidMaster', text: 'BidMaster — procurement redefined', url };
    try {
      if (navigator.share) {
        await navigator.share(payload);
      } else if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      }
    } catch {
      /* user cancelled or unsupported */
    }
  };

  return (
    <button type="button" onClick={share} className={`${navLink} hidden md:inline-flex items-center gap-2`}>
      <svg className="h-4 w-4 shrink-0 opacity-80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden>
        <circle cx="18" cy="5" r="2.5" />
        <circle cx="6" cy="12" r="2.5" />
        <circle cx="18" cy="19" r="2.5" />
        <path strokeLinecap="round" d="M8.5 10.5L15.5 6.5M8.5 13.5l7 4" />
      </svg>
      Share
    </button>
  );
}

export function PublicHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-[100] bg-white/80 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-20 flex items-center justify-between">
        <BidMasterLogo href="/" />
        <nav className="flex items-center gap-4 md:gap-8">
          <Link to="/#features" className={`${navLink} hidden md:inline`}>
            Features
          </Link>
          <Link to="/#how-it-works" className={`${navLink} hidden md:inline`}>
            How it Works
          </Link>
          <ShareNavButton />
          <Link
            to="/signin"
            className="text-sm font-black text-blue-600 px-5 py-2.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 transition-colors shadow-sm"
          >
            Sign In
          </Link>
        </nav>
      </div>
    </header>
  );
}

/** Offset for `fixed` public header (`h-20`). Use on pages that include `PublicHeader`. */
export const publicHeaderTopPaddingClass = 'pt-20';
